/**
 * 将站内上传资源放到当前应用的部署前缀下。
 * 本地开发为 /uploads/...，外网预览为 /_preview/uploads/...。
 */
export function publicUploadUrl(path: string): string {
  if (!path.startsWith('/uploads/')) return path;
  return `${import.meta.env.BASE_URL.replace(/\/$/, '')}${path}`;
}
